import { WidgetConfig, WidgetEventHandler, WidgetEventType } from './../../types';
import { apiGet, APIURL, cancelSelectEvent, getCSSStyles, getHeaderPinButtonHTML, getHeaderPinStateClass, getNoDataHTML, getWidgetDataURI, isHeaderPinned, normalizeWidgetTheme, setupHeaderPin, toggleWidgetTheme } from './../../helpers';

export class TraderverseIndexesCompositionChangeOverTimeDataTable {
  private container: HTMLElement;
  private shadowRoot: ShadowRoot;
  private looserData: any = null;
  private eventListeners: { [event: string]: Function[] } = {};
  private eventHandlers: Map<WidgetEventType, WidgetEventHandler[]> = new Map();
  private config: WidgetConfig;
  private updateInterval: any = null;
  private widgetResizeObserver: any = null;
  private lastFetchedAt: Date | null = null;
  constructor(config: WidgetConfig) {
    this.config = config;
    this.config.theme = normalizeWidgetTheme(this.config.theme);
    this.container = this.resolveContainer(config.container);
    if ((this.container as any).shadowRoot) {
      this.shadowRoot = (this.container as any).shadowRoot;
    } else {
      this.shadowRoot = this.container.attachShadow({ mode: 'closed' });
    }
    this.init();
  }

  private async init(): Promise<void> {
    this.attachStyles();
    this.renderBiggestloosersWidget(true); // show loading
    await this.fetchBiggestloosers('5d');
    this.setLoading(false); // remove loading
    cancelSelectEvent(this.shadowRoot);
  }

  public on(event: string, listener: Function): void {
    if (!this.eventListeners[event]) {
      this.eventListeners[event] = [];
    }
    this.eventListeners[event].push(listener);
  }

  public off(event: string, listener: Function): void {
    if (!this.eventListeners[event]) return;
    this.eventListeners[event] = this.eventListeners[event].filter(l => l !== listener);
  }

  private emit(event: string, ...args: any[]): void {
    if (this.eventListeners[event]) {
      this.eventListeners[event].forEach(listener => listener(...args));
    }
  }

  private formatMarketCap(value: number): string {
  if (value >= 1e12) {
    return (value / 1e12).toFixed(2) + 'T';
  }
  if (value >= 1e9) {
    return (value / 1e9).toFixed(2) + 'B';
  }
  if (value >= 1e6) {
    return (value / 1e6).toFixed(2) + 'M';
  }
  if (value >= 1e3) {
    return (value / 1e3).toFixed(2) + 'K';
  }
  return value.toString();
}


  private async fetchBiggestloosers(interval: string = '5d'): Promise<void> {
    this.setLoading(true);
    try {
      const url = `${APIURL}/v3/discover/movers?type=Looser&interval=${encodeURIComponent(interval)}`;
      const response = await apiGet({
        url,
        method: 'GET',
      });

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
      this.looserData = data?.data?.looser || [];
      const fromApi = (data as any)?.last_updated_at ?? (data as any)?.data?.last_updated_at;
      this.lastFetchedAt = fromApi ? new Date(fromApi) : new Date();
      console.log('looser Data:', this.looserData);
      this.renderlooserRows();
    } catch (err) {
      console.error('Failed to fetch biggest loosers:', err);
    } finally {
      this.setLoading(false);
    }
  }

  

  private async attachStyles(): Promise<void> {
    try {
      const styleEl = await getCSSStyles();
      this.shadowRoot.appendChild(styleEl);
    } catch (err) {
      console.error('Failed to load CSS file:', err);
    }
  }

  private resolveContainer(container: string | HTMLElement): HTMLElement {
    if (typeof container === 'string') {
      const el = document.getElementById(container) || document.querySelector(container);
      if (!el) throw new Error(`Container not found: ${container}`);
      return el as HTMLElement;
    }
    return container;
  }

private renderBiggestloosersWidget(loading: boolean = false): void {
  let themeClass = 'defaultDarkMode';
let dataTheme = 'default-dark';

if (this.config.theme === 'white') {
  themeClass = 'whiteMode';
  dataTheme = 'white';
} else if (this.config.theme === 'black') {
  themeClass = 'blackMode';
  dataTheme = 'black';
}
  this.shadowRoot.innerHTML = `
    <div style="width: ${typeof this.config.width == "number" ? this.config.width+ 'px' : this.config.width  };height: ${typeof this.config.height == "number" ? this.config.height+ 'px' : this.config.height};" class="widgetBox ${themeClass} loading ${getHeaderPinStateClass(this.config)}" data-theme="${dataTheme}">
      <div class="headTop">
        <h4 class="title market">${this.getTitleIconSvg()} Indexes Composition Change Over Time (Data Table)
        </h4>
        <div class="actionCol">${getHeaderPinButtonHTML(this.config)}<tooltip-wrapper id="lastUpdatedTooltip"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.625 6.625C0.625 7.41293 0.780195 8.19315 1.08172 8.9211C1.38325 9.64905 1.82521 10.3105 2.38236 10.8676C2.93951 11.4248 3.60095 11.8667 4.3289 12.1683C5.05685 12.4698 5.83707 12.625 6.625 12.625C7.41293 12.625 8.19315 12.4698 8.9211 12.1683C9.64905 11.8667 10.3105 11.4248 10.8676 10.8676C11.4248 10.3105 11.8667 9.64905 12.1683 8.9211C12.4698 8.19315 12.625 7.41293 12.625 6.625C12.625 5.0337 11.9929 3.50758 10.8676 2.38236C9.74242 1.25714 8.2163 0.625 6.625 0.625C5.0337 0.625 3.50758 1.25714 2.38236 2.38236C1.25714 3.50758 0.625 5.0337 0.625 6.625Z" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/> <path d="M6.625 3.2915V6.62484L8.625 8.62484" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/> </svg><tooltip><span>Last Updated</span><strong>N/A</strong></tooltip></tooltip-wrapper><i class="pi pi-ellipsis-v"></i></div>
      </div>

      <div class="inBody">
        <div class="optionsRow">
          <div class="item"></div>
          <span></span>
          <div class="item">
            <select class="timeperiod-select">
              <option value="1d">1 Day</option>
              <option value="5d" selected="">5 Day</option>
              <option value="1m" >This Month</option>
              <option value="1y">This Year</option>
            </select>
          </div>
        </div>

        <div class="chartDv" id="analystPriceTargetContainer">
          <div class="eventsMain style02 customGrid" style="--grid-template-columns: 1.2fr 1fr 1fr 1fr 1fr; min-width:400px;">
            <div class="item header">
              <p>Ticker</p>
              <p>Price</p>
              <p>% Change</p>
              <p>Market Cap</p>
              <p>Vol</p>
            </div>
            <div class="bodyContainer"></div>
          </div>
        </div>
      </div>
    </div>
  `;

  const filtersToggleBtn = this.shadowRoot.querySelector('.filters-toggle');
  const filtersBox = this.shadowRoot.querySelector('.filtersBox');
  if (filtersToggleBtn && filtersBox) {
    filtersToggleBtn.addEventListener('click', () => {
      filtersBox.classList.toggle('hidden');
    });
  }

  const timeperiodSelect = this.shadowRoot.querySelector('.timeperiod-select') as HTMLSelectElement;
  if (timeperiodSelect) {
    timeperiodSelect.addEventListener('change', (e) => {
      const interval = (e.target as HTMLSelectElement).value;
      this.fetchBiggestloosers(interval);
    });
  }

  this.renderlooserRows();
}
  /**
   * Adds or removes the 'loading' class on the widgetBox
   */
  private setLoading(loading: boolean): void {
    const widgetBox = this.shadowRoot.querySelector('.widgetBox');
    if (widgetBox) {
      if (loading) {
        widgetBox.classList.add('loading');
      } else {
        widgetBox.classList.remove('loading');
      }
    }
  }

  private formatLastUpdated(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: 'America/New_York',
    };
    return date.toLocaleString('en-US', options).replace(',', '').replace(/\//g, '-') + ' EST';
  }

  private updateLastUpdatedTooltip(): void {
    const lastUpdated = this.lastFetchedAt ? this.formatLastUpdated(this.lastFetchedAt) : 'N/A';
    const tooltip = this.shadowRoot.querySelector('#lastUpdatedTooltip tooltip strong');
    if (tooltip) tooltip.innerHTML = lastUpdated.replace(' ', '<br>');
  }

  private renderlooserRows(): void {
    this.updateLastUpdatedTooltip();
  
    const container = this.shadowRoot.querySelector('.bodyContainer') as HTMLElement;
    if (!container) return;
  
    if (!Array.isArray(this.looserData) || this.looserData.length === 0) {
      container.innerHTML = getNoDataHTML();
      return;
    }
  
    container.innerHTML = '';
  
    this.looserData.forEach((looser: any) => {
      const marketCapValue =
        typeof looser.market_cap === 'number'
          ? this.formatMarketCap(looser.market_cap)
          : '-';
  
      const price =
        typeof looser.price === 'number'
          ? looser.price.toFixed(2)
          : '-';
  
      const pctChange =
        typeof looser.pct_change === 'number'
          ? `${looser.pct_change.toFixed(2)}%`
          : '-';
  
      const volume =
        typeof looser.relative_volume === 'number'
          ? looser.relative_volume.toLocaleString()
          : '-';
  
      const logoUrl = `https://storage.googleapis.com/analytics-images-traderverse/stocks_v1/${looser.symbol}.svg`;
  
      const row = document.createElement('div');
      row.className = 'item body';
  
      row.innerHTML = `
        <p class="initials">
          <img src="${logoUrl}"
               alt="${looser.symbol}"
               style="width:24px;height:24px;border-radius:4px;" />
          <span>${looser.symbol || '-'}</span>
        </p>
  
        <p>${price}</p>
  
        <p>
          <span class="${looser.pct_change < 0 ? 'rangeFigure red' : 'rangeFigure green'}">
            ${pctChange}
          </span>
        </p>
  
        <p>
          <span class="rangeFigure red">
            ${marketCapValue}
          </span>
        </p>
  
        <p class="stat">${volume}</p>
      `;
  
      container.appendChild(row);
    });
  }

  public async getWidgetImage(): Promise<string> {
    const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
    return await getWidgetDataURI(widget);
  }

    private updateDisplay(): void {
  const widget = this.shadowRoot.querySelector('.chartDv') as HTMLElement;

  const hasData =
    Array.isArray(this.looserData) &&
    this.looserData.length > 0;

  if (hasData) { 
    widget?.setAttribute('data-testing-id', 'biggest-losers');
  } else {
    widget?.removeAttribute('data-testing-id');
  }

  if (!hasData) {
    setTimeout(() => this.updateDisplay(), 100);
    return;
  }

  this.renderlooserRows();
}


  
  public setTheme(theme: 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite'): void {
    if (!this.shadowRoot) return;
  
    this.config.theme = toggleWidgetTheme(
      this.shadowRoot,
      theme
    ) as 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite';
  
    this.updateDisplay();
  }

  public destroy(): void {
    if (this.updateInterval) { clearInterval(this.updateInterval); this.updateInterval = null; }
    if (this.widgetResizeObserver) { this.widgetResizeObserver.disconnect(); this.widgetResizeObserver = null; }
    this.eventHandlers.clear(); this.shadowRoot.innerHTML = '';
  }


  private getTitleIconSvg(): string {
    return `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.75 28.4375H11.25C4.4625 28.4375 1.5625 25.5375 1.5625 18.75V11.25C1.5625 4.4625 4.4625 1.5625 11.25 1.5625H18.75C25.5375 1.5625 28.4375 4.4625 28.4375 11.25V18.75C28.4375 25.5375 25.5375 28.4375 18.75 28.4375ZM11.25 3.4375C5.4875 3.4375 3.4375 5.4875 3.4375 11.25V18.75C3.4375 24.5125 5.4875 26.5625 11.25 26.5625H18.75C24.5125 26.5625 26.5625 24.5125 26.5625 18.75V11.25C26.5625 5.4875 24.5125 3.4375 18.75 3.4375H11.25Z" fill="currentColor"/>
            <path d="M9.16252 19.05C8.96252 19.05 8.76252 18.9875 8.58752 18.85C8.17502 18.5375 8.10002 17.95 8.41252 17.5375L11.3875 13.675C11.75 13.2125 12.2625 12.9125 12.85 12.8375C13.425 12.7625 14.0125 12.925 14.475 13.2875L16.7625 15.0875C16.85 15.1625 16.9375 15.1625 17 15.15C17.05 15.15 17.1375 15.125 17.2125 15.025L20.1 11.3C20.4125 10.8875 21.0125 10.8125 21.4125 11.1375C21.825 11.45 21.9 12.0375 21.575 12.45L18.6875 16.175C18.325 16.6375 17.8125 16.9375 17.225 17C16.6375 17.075 16.0625 16.9125 15.6 16.55L13.3125 14.75C13.225 14.675 13.125 14.675 13.075 14.6875C13.025 14.6875 12.9375 14.7125 12.8625 14.8125L9.88752 18.675C9.72502 18.925 9.45002 19.05 9.16252 19.05Z" fill="currentColor"/>
          </svg>`;
  }

}

declare global {
  interface Window { TraderverseIndexesCompositionChangeOverTimeDataTable?: typeof TraderverseIndexesCompositionChangeOverTimeDataTable; }
}

if (typeof window !== 'undefined') {
  window.TraderverseIndexesCompositionChangeOverTimeDataTable = TraderverseIndexesCompositionChangeOverTimeDataTable;
}